module.exports = __webpack_public_path__ + "assets/img/36_512.5ebcbfcb.jpg";